angular.module('gym.components').directive('reviewAffectedBookings', function() {
  return {
    restrict: 'E',
    template: require('templates/components/profile/reviewAffectedBookings.html.slim'),
    scope: {
      trainerAvailability: '='
    }
  };
});
